import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RoleEnum, User, Holder, Officer } from "../../interfaces";

export interface UserState {
  currentRole: RoleEnum | undefined;
  currentUser: User | Holder | Officer | undefined;
  isAuthenticated: boolean;
}

const initialState: UserState = {
  currentRole: undefined,
  currentUser: undefined,
  isAuthenticated: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.currentUser = action.payload;
      state.currentRole = action.payload.roles && action.payload.roles[0];
      state.isAuthenticated = true;
    },
    clearUser: (state) => {
      state.currentUser = undefined;
      state.currentRole = undefined;
      state.isAuthenticated = false;
    },
    changeRole: (state, action: PayloadAction<RoleEnum>) => {
      state.currentRole = action.payload;
    },
  },
});

export const { setUser, clearUser, changeRole } = userSlice.actions;
export default userSlice.reducer;
